import styled from 'styled-components';

import { ThemeType } from '../../../../../themeStyled';

interface P2Props {
	'data-test-id'?: string;
}

const P2 = styled.p<P2Props>`
	font-weight: normal;
	font-size: 1.2rem;
	line-height: 171%;
	margin: 0;
	font-style: normal;
	color: black;

	@media (max-width: ${({ theme }: { theme: ThemeType }) => theme.breakpoints.md}) {
		font-size: 1rem;
	}
`;

export default P2;
